import { Download, FileText } from "lucide-react";
import { STORY_PDF } from "../../data/content";

export const StoryDocument = () => (
  <div
    data-testid="story-pdf-card"
    className="bg-neutral-900 border border-neutral-800 border-l-4 border-l-red-600 p-6"
  >
    <div className="flex items-start gap-4">
      <span className="w-12 h-12 shrink-0 bg-red-600 flex items-center justify-center">
        <FileText className="w-6 h-6 text-white" />
      </span>
      <div className="min-w-0">
        <div className="mono-label text-xs text-red-500 uppercase tracking-wider mb-1">
          Documento ufficiale &bull; PDF
        </div>
        <h3 className="font-display text-lg font-bold uppercase text-white leading-tight">
          Davide Bolognesi — Il Finnico e la storia del Legend Team
        </h3>
        <p className="text-xs text-neutral-400 mt-2 leading-relaxed">
          Dalle prove speciali alla costruzione di un sogno condiviso: prologo, Finnico
          Corse, nascita del Legend Team, Legend Village, Legend Magazine, cronologia e fonti.
        </p>
      </div>
    </div>
    <div className="flex flex-wrap gap-3 mt-6">
      <a
        data-testid="story-pdf-open"
        href={STORY_PDF}
        target="_blank"
        rel="noopener noreferrer"
        className="px-5 py-2.5 bg-red-600 hover:bg-red-500 text-white text-xs font-black uppercase tracking-widest transition-colors"
      >
        Leggi la storia completa
      </a>
      <a
        data-testid="story-pdf-download"
        href={STORY_PDF}
        download="Davide-Bolognesi-Legend-Team.pdf"
        className="inline-flex items-center gap-2 px-5 py-2.5 border border-neutral-700 hover:border-red-600 text-neutral-200 hover:text-red-500 text-xs font-bold uppercase tracking-widest transition-colors"
      >
        <Download className="w-4 h-4" /> Scarica PDF
      </a>
    </div>
  </div>
);
